import React, { useEffect, useState } from "react";
import { getVodInfo, getSeriesInfo } from "../../other/load-playlist";
import { optimizeName } from "../../other/vod-series-name-optimizer";
import { useParams, Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Seasons from "../Series/Seasons";
import DB from "../../other/local-db";
import { generateUrl } from "../../other/generate-url";
import { Tooltip } from "@mui/material";
import { PlayArrow, Info } from "@mui/icons-material";
import { Star, StarBorder } from "@mui/icons-material";
import { toggleFavorite, selectIsFavorite } from "../../slices/favoritesSlice";

import { Box, Typography, Button, IconButton, Grid } from "@mui/material";
import YouTubeIcon from '@mui/icons-material/YouTube';
import CloseIcon from "@mui/icons-material/Close";

const MoreInfo = ({ style }) => {
  const { category, stream_id, playingMode } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const isFavorite = useSelector(selectIsFavorite(playingMode, stream_id));
  const stream = useSelector((state) => state.playlist).find((x) =>
    playingMode === "series"
      ? parseInt(x.series_id) === parseInt(stream_id)
      : parseInt(x.stream_id) === parseInt(stream_id)
  );
  const [expandDescription, setExpandDescription] = useState(false);
  const [Name, setName] = useState(stream && optimizeName(stream.name));
  const [Description, setDescription] = useState("");
  const [ImageSrc, setImageSrc] = useState(stream && stream.stream_icon);
  const [Rating, setRating] = useState(false);
  const [youtubeId, setYoutubeId] = useState(null);
  const [backdropPath, setBackdropPath] = useState(null);
  const [Genres, setGenres] = useState("");
  const [Actor, setActor] = useState("");
  const [Year, setYear] = useState("");
  const [seasons, setSeasons] = useState({});
  const [favorite, setFavorite] = useState(null);
  const [url, setUrl] = useState();
  const [result, setResult] = useState(null);
  const isSeries = playingMode === "series";

  useEffect(() => {
    setFavorite(isFavorite);
  }, [isFavorite]);

  useEffect(() => {
    async function fetchData() {
      if (!stream) {
        history.replace(`/${playingMode}/`);
        return;
      }
      const infoFunction =
        playingMode === "series" ? getSeriesInfo : getVodInfo;
      infoFunction(
        playingMode === "series" ? stream.series_id : stream.stream_id,
        stream.name,
        false,
        stream.tmdb
      ).then((result) => {
        if (result && result.info) {
          let info = result.info;
          info.name && setName(info.name);
          info.description && setDescription(info.description);
          info.image && setImageSrc(info.image);
          info.cover && setImageSrc(info.cover);
          info.youtube_trailer && setYoutubeId(info.youtube_trailer);
          info.backdrop_path &&
            info.backdrop_path.length > 0 &&
            setBackdropPath(info.backdrop_path[0]);
          info.genre && setGenres(info.genre);
          info.actors && setActor(info.actors);
          info.releasedate && setYear(info.releasedate);
          if (info.rating) {
            const push = { full: [], empty: [], half: false };
            const quotient = Math.floor(info.rating / 2);
            const remainder = info.rating % 2 > 0 ? 1 : 0;
            for (let i = 0; i < quotient; i++) push.full.push(1);
            for (
              let i = 0;
              i < 5 - remainder - quotient + (quotient === 1 ? 0 : 1);
              i++
            )
              push.empty.push(1);
            push.half = quotient === 1;
            setRating({ ...push });
          }
          setResult(result);
          playingMode === "series" && setSeasons(result.episodes);
        }
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (!stream) return;
    playingMode === "movie" &&
      setUrl(
        generateUrl("movie", stream.stream_id, stream.container_extension)
      );
  }, [stream]);

  const handleFavorite = (event) => {
    event.stopPropagation();
    dispatch(
      toggleFavorite({ mode: playingMode, id: stream_id, data: result })
    );
  };

  if (result === null) return null;

  const {
    movie_image,
    name: movieName,
    plot,
    genre,
    cast,
    rating,
    director,
    youtube_trailer,
    releasedate,
  } = result?.info;

  return (
    <Box
      sx={{
        position: "fixed",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        userSelect: "none",
        backgroundColor: "#181818",
        overflowY: "auto",
        ...style,
      }}
    >
      <IconButton
        onClick={() => history.goBack()}
        sx={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          color: "white",
          zIndex: 1000000,
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          borderRadius: "50%",
          padding: "0.5rem",
        }}
      >
        <CloseIcon fontSize="large" />
      </IconButton>
      <Box
        style={style}
        sx={{
          height: "calc(75vh - 3rem)",
          position: "relative",
          zIndex: 1000,
        }}
      >
        {youtubeId || !backdropPath ? (
          <Box
            sx={{
              position: "absolute",
              width: "100vw",
              height: "calc(100vh)",
              top: 0,
              left: 0,
              overflow: "hidden",
              zIndex: -99999,
            }}
          >
            {youtubeId && (
              <iframe
                frameBorder="0"
                height="100%"
                width="100%"
                title="youtube-bg"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "200%",
                  width: "260%%",
                  marginTop: "-420px",
                }}
                src={`https://youtube.com/embed/${youtubeId}?autoplay=1&controls=0&showinfo=0&autohide=1&mute=1&loop=1&disablekb=1&modestbranding=1&playlist=${youtubeId}&origin=http://localhost:3006`}
              ></iframe>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              position: "absolute",
              height: "calc(75vh - 4rem)",
              top: 0,
              left: 0,
              zIndex: -1,
              width: "100vw",
            }}
          />
        )}
        <Box
          sx={{
            color: "white",
            position: "absolute",
            width: "100vw",
            height: "calc(70vh - 3rem)",
            zIndex: 2,
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  borderRadius: "8px",
                  padding: "2rem",
                  marginLeft: "2rem",
                  marginTop: "2rem",
                }}
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {movieName}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    marginBottom: "1rem",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {plot}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ marginBottom: "0.5rem", color: "gray" }}
                >
                  <strong>Genre:</strong> {genre}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    marginBottom: "0.5rem",
                    color: "gray",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <strong>Cast:</strong> {cast}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ marginBottom: "0.5rem", color: "gray" }}
                >
                  <strong>Director:</strong> {director}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ marginBottom: "0.5rem", color: "gray" }}
                >
                  <strong>Release Date:</strong> {releasedate}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    display: "inline-block",
                    padding: "0.25rem 0.5rem",
                    backgroundColor: "gray",
                    borderRadius: "4px",
                    color: "white",
                  }}
                >
                  Rating: {rating}
                </Typography>
                <Box
                  sx={{
                    marginTop: "1rem",
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  {!isSeries && (
                    <Tooltip title="Play">
                      <IconButton
                        component={Link}
                        to={`/movie/category/${category}/${stream_id}/play/`}
                        color="inherit"
                        sx={{
                          backgroundColor: "rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <PlayArrow />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="More Info">
                    <IconButton
                      component={Link}
                      to={`/${
                        isSeries ? "series" : "movie"
                      }/category/${category}/${stream_id}/info/`}
                      color="inherit"
                      sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      <Info />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={
                      favorite ? "Remove from favorites" : "Add to favorites"
                    }
                  >
                    <IconButton
                      onClick={handleFavorite}
                      color="inherit"
                      sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      {favorite ? <Star /> : <StarBorder />}
                    </IconButton>
                  </Tooltip>
                  {youtubeId && (
                    <Tooltip title="Watch Trailer">
                      <IconButton
                        href={`https://www.youtube.com/watch?v=${youtubeId}`}
                        target="_blank"
                        sx={{
                          backgroundColor: "rgba(255, 255, 255, 0.2)",
                        }}
                      >
                        <YouTubeIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            </Grid>
            {playingMode === "series" && (
              <Grid item xs={12} sm={12}>
                <Seasons
                  seasonData={seasons}
                  cover={backdropPath || ImageSrc}
                />
              </Grid>
            )}
          </Grid>
        </Box>
        <Box
          sx={{
            position: "absolute",
            width: "100vw",
            height: "23vh",
            bottom: 0,
            left: 0,
            zIndex: 0,
          }}
        />
      </Box>
    </Box>
  );
};

export default MoreInfo;
